import React, {Component} from 'react';
import {action, observable} from 'mobx';
import {inject, observer} from 'mobx-react';
import {
  Button,
  FormInput,
  FormSelect,
  FormCheckbox,
  Modal,
  ModalHeader,
  ModalBody
} from "shards-react";
import PageTitle from "../../../components/common/PageTitle";
import ModalProductList from "../../../components/modal/ModalProductList";
import {toast} from "react-toastify";
import _ from "underscore";
import FeatherIcon from 'feather-icons-react';


@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me }))
@inject(({ common }) => ({ getStoreTotalConfig: common.getStoreTotalConfig, updateDoc: common.updateDoc, getDoc: common.getDoc }))
@inject(({ review }) => ({
  getSurveyReviewList: review.getSurveyReviewList,
  getSurveyReview: review.getSurveyReview,
  getSurveyReviewTree: review.getSurveyReviewTree,
  updateSurveyReview: review.updateSurveyReview,
  deleteSurveyReview: review.deleteSurveyReview,
  deleteSurveyReviews: review.deleteSurveyReviews,
  updateSurveyReviewOrder: review.updateSurveyReviewOrder,
  getSurveyProductGroupList: review.getSurveyProductGroupList,
  updateSurveyProductGroup: review.updateSurveyProductGroup,
  removeSurveyProductGroup: review.removeSurveyProductGroup
}))

@observer
class surveyReviewConfig extends Component {

  @observable shopUser = {};
  @observable shopInfo = {};
  @observable isLogin = false;

  @observable basicSettings = {
    surveyConfig: {
      enableSurvey: "no",
      questions: []
    }
  };

  @observable newQuestion = {
    question: "",
    type: "text",
    required: false,
    options: [],
    maxSelections: null
  };

  @observable newOption = "";

  @observable questionTemplates = [
    {
      id: "size",
      label: "사이즈",
      question: "구매하신 제품의 사이즈는 어떠셨나요?",
      type: "radio",
      required: false,
      options: ["작아요", "딱 맞아요", "커요"]
    },
    {
      id: "delivery",
      label: "배송",
      question: "배송은 만족스러우셨나요?",
      type: "radio",
      required: false,
      options: ["매우 만족", "만족", "보통", "불만족", "매우 불만족"]
    },
    {
      id: "expiration",
      label: "유통기간",
      question: "제품의 유통기한은 충분했나요?",
      type: "radio",
      required: false,
      options: ["충분했어요", "적당했어요", "부족했어요"]
    },
    {
      id: "satisfaction",
      label: "만족도",
      question: "제품에 대한 전반적인 만족도는 어떠셨나요?",
      type: "radio",
      required: false,
      options: ["매우 만족", "만족", "보통", "불만족", "매우 불만족"]
    },
    {
      id: "productRating",
      label: "제품 별점",
      question: "제품을 별점으로 평가해주세요",
      type: "rating",
      required: false,
      options: []
    },
    {
      id: "goodPoints",
      label: "어떤 점이 좋았나요?",
      question: "어떤 점이 좋았나요?",
      type: "checkbox",
      required: false,
      options: ["가격", "품질", "디자인", "배송", "포장"],
      maxSelections: 5
    },
    {
      id: "repurchase",
      label: "재구매 의향",
      question: "재구매 의향이 있으신가요?",
      type: "radio",
      required: false,
      options: ["네, 재구매 할게요", "아직 모르겠어요", "아니요"]
    },
    {
      id: "recommend",
      label: "추천 의향",
      question: "주변에 추천하고 싶으신가요?",
      type: "radio",
      required: false,
      options: ["적극 추천", "추천", "보통", "비추천", "적극 비추천"]
    },
    {
      id: "color",
      label: "색상",
      question: "색상은 사진과 동일했나요?",
      type: "radio",
      required: false,
      options: ["동일해요", "비슷해요", "달라요"]
    },
    {
      id: "quality",
      label: "품질",
      question: "제품의 품질은 어떠셨나요?",
      type: "radio",
      required: false,
      options: ["기대 이상", "기대대로", "기대 이하"]
    },
    {
      id: "improvement",
      label: "개선사항",
      question: "개선되었으면 하는 점이 있나요?",
      type: "textarea",
      required: false,
      options: []
    }
  ];

  @observable selectedTemplate = "";

  // 탭 상태
  @observable activeTab = "product"; // "product" (기본 화면). 설문지 리스트는 모달로 분리됨.
  @observable showSurveyListModal = false;
  @observable assigningSurveyId = null; // 모달에서 선택한 배정 대상 설문지 _id

  // 현재 보기 상태: "groupList" (그룹 목록) 또는 "questionList" (설문 항목 목록)
  @observable currentView = "groupList";
  @observable selectedGroup = null;

  // 설문지 그룹 관련
  @observable surveyGroups = [];
  @observable newGroupName = "";

  // 질문 아이템 관련
  @observable groupQuestions = []; // 선택된 그룹의 질문 목록

  // 모달 상태
  @observable showWriteModal = false;
  @observable showGroupModal = false;

  // 수정 모드
  @observable isEditMode = false;
  @observable editingQuestion = null; // 수정 중인 질문 객체

  // 상품 별 설문 관련 (설문지 상품 그룹)
  @observable surveyProductGroups = []; // 설문지 상품 그룹 리스트
  @observable newSurveyProductGroupName = ""; // 새 그룹 이름
  @observable newGroupError = ""; // 새 그룹 이름 유효성 에러
  @observable selectedSurveyProductGroup = null; // 선택된 그룹
  @observable surveyProductGroupProducts = []; // 선택된 그룹의 상품 목록

  // UX 리뉴얼
  @observable collapsedGroupIds = {}; // 그룹 카드 접힘 상태 {_id: true}
  @observable productViewMode = {}; // {groupId: 'grid' | 'list'}
  @observable editingGroupNameId = null; // 인라인 편집 중인 그룹 id
  @observable draftGroupName = '';
  @observable dirtyGroupIds = {}; // 저장 필요 표시

  // 모달 상태 (상품 선택 모달용)
  @observable modals = {
    ModalProductList: false
  };
  @observable added_ids = []; // 이미 추가된 상품 ID

  constructor(props) {
    super(props);
    this.init()
  }

  @action
  init = async () => {
    if(this.props.isLogin) {
      let _this = this;
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.store = this.props.me.store ? this.props.me.store : {};
      this.isUse = false;
      if(this.teamUser.isPaidShop) {
        this.isUse = true;
      }
      this.permissions = this.props.me.permissions;

      // 기존 설정 로드 (enableSurvey)
      this.props.getStoreTotalConfig({store_id: this.teamUser.selStore_id, shopNo:this.teamUser.selShopNo ? this.teamUser.selShopNo : 1}, function(res) {
        if(res.basicSettings) {
          let getSettings = _.pick(res.basicSettings, 'surveyConfig');
          _this.basicSettings = {..._this.basicSettings , ...getSettings};
        }
        _this.basicSettings.store_id = _this.teamUser.selStore_id;
        _this.basicSettings.shopNo = _this.teamUser.selShopNo ? _this.teamUser.selShopNo : 1;
      });

      // 설문 리뷰 리스트 로드 (새 API)
      this.loadSurveyGroups();

      // 설문 상품 그룹 리스트 로드
      this.loadSurveyProductGroups();
    }
  };

  // 설문 상품 그룹 리스트 로드
  @action
  loadSurveyProductGroups = () => {
    let _this = this;
    this.props.getSurveyProductGroupList({
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      limit: 100,
      page: 1
    }, function(res) {
      if (res && res.docs) {
        _this.surveyProductGroups = res.docs;
      }
    });
  }

  // 설문 그룹 리스트 로드
  @action
  loadSurveyGroups = () => {
    let _this = this;
    this.props.getSurveyReviewList({
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      type: 'group',
      limit: 100,
      page: 1
    }, function(res) {
      if(res && res.docs) {
        _this.surveyGroups = res.docs;
      }
    });
  }

  updateSurveyConfig = async (event) => {
    this.props.updateDoc('updateBasicSettings', this.basicSettings, function(res) {
      if(res.errors && res.errors.length > 0) {
        toast(res.errors[0].message);
      }
      else {
        toast('저장 되었습니다.');
      }
    });
  }

  addQuestion = () => {
    if (!this.newQuestion.question.trim()) {
      toast('질문을 입력해주세요.');
      return;
    }

    if ((this.newQuestion.type === 'radio' || this.newQuestion.type === 'checkbox') && this.newQuestion.options.length === 0) {
      toast('선택형 질문은 최소 1개 이상의 옵션이 필요합니다.');
      return;
    }

    this.basicSettings.surveyConfig.questions.push({
      ...this.newQuestion,
      id: Date.now()
    });

    this.newQuestion = {
      question: "",
      type: "text",
      required: false,
      options: [],
      maxSelections: null
    };
  }

  removeQuestion = (id) => {
    this.basicSettings.surveyConfig.questions = this.basicSettings.surveyConfig.questions.filter(q => q.id !== id);
  }

  addOption = () => {
    if (!this.newOption.trim()) {
      toast('옵션을 입력해주세요.');
      return;
    }

    this.newQuestion.options.push(this.newOption);
    this.newOption = "";
  }

  removeOption = (index) => {
    this.newQuestion.options.splice(index, 1);
  }

  moveQuestion = (index, direction) => {
    const newIndex = direction === 'up' ? index - 1 : index + 1;
    if (newIndex < 0 || newIndex >= this.basicSettings.surveyConfig.questions.length) return;

    const questions = [...this.basicSettings.surveyConfig.questions];
    [questions[index], questions[newIndex]] = [questions[newIndex], questions[index]];
    this.basicSettings.surveyConfig.questions = questions;
  }

  addTemplateQuestion = () => {
    if (!this.selectedTemplate) {
      toast('템플릿을 선택해주세요.');
      return;
    }

    const template = this.questionTemplates.find(t => t.id === this.selectedTemplate);
    if (!template) return;

    this.basicSettings.surveyConfig.questions.push({
      ...template,
      id: Date.now()
    });

    this.selectedTemplate = "";
    toast('템플릿 질문이 추가되었습니다.');
  }

  // 탭 전환
  changeTab = (tab) => {
    this.activeTab = tab;
  }

  // 모달 토글
  toggleWriteModal = () => {
    this.showWriteModal = !this.showWriteModal;
    if (!this.showWriteModal) {
      // 모달 닫을 때 폼 초기화
      this.newQuestion = {
        question: "",
        type: "text",
        required: false,
        options: [],
        maxSelections: null
      };
      this.newOption = "";
      this.selectedTemplate = "";
      this.isEditMode = false;
      this.editingQuestion = null;
    }
  }

  // 질문 선택하여 수정 모달 열기
  openEditQuestionModal = (question) => {
    this.editingQuestion = question;
    this.isEditMode = true;
    this.newQuestion = {
      question: question.name || "",
      type: (question.options && question.options.questionType) || "text",
      required: (question.options && question.options.required) || false,
      options: (question.options && question.options.choices) || [],
      maxSelections: (question.options && question.options.maxSelections) || null
    };
    this.showWriteModal = true;
  }

  // 질문 수정 저장
  updateQuestion = () => {
    if (!this.newQuestion.question.trim()) {
      toast('질문을 입력해주세요.');
      return;
    }

    if ((this.newQuestion.type === 'radio' || this.newQuestion.type === 'checkbox') && this.newQuestion.options.length === 0) {
      toast('선택형 질문은 최소 1개 이상의 옵션이 필요합니다.');
      return;
    }

    let _this = this;

    this.props.updateSurveyReview({
      _id: this.editingQuestion._id,
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      name: this.newQuestion.question,
      options: {
        questionType: this.newQuestion.type,
        required: this.newQuestion.required,
        choices: this.newQuestion.options,
        maxSelections: this.newQuestion.maxSelections
      }
    }, function(res) {
      if (res && res.data) {
        // 로컬 상태 업데이트
        var updatedQuestion = {
          ..._this.editingQuestion,
          name: _this.newQuestion.question,
          options: {
            questionType: _this.newQuestion.type,
            required: _this.newQuestion.required,
            choices: _this.newQuestion.options,
            maxSelections: _this.newQuestion.maxSelections
          }
        };

        _this.groupQuestions = _this.groupQuestions.map(function(q) {
          return q._id === _this.editingQuestion._id ? updatedQuestion : q;
        });

        // 폼 초기화
        _this.newQuestion = {
          question: "",
          type: "text",
          required: false,
          options: [],
          maxSelections: null
        };
        _this.showWriteModal = false;
        _this.isEditMode = false;
        _this.editingQuestion = null;
        toast('질문이 수정되었습니다.');
      } else {
        toast('질문 수정에 실패했습니다.');
      }
    });
  }

  // 그룹 모달 토글
  toggleGroupModal = () => {
    this.showGroupModal = !this.showGroupModal;
    if (!this.showGroupModal) {
      this.newGroupName = "";
    }
  }

  // 설문지 그룹 추가
  addSurveyGroup = () => {
    if (!this.newGroupName.trim()) {
      toast('설문지 이름을 입력해주세요.');
      return;
    }

    let _this = this;
    this.props.updateSurveyReview({
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      type: 'group',
      name: this.newGroupName.trim(),
      isActive: true,
      options: { questions: [] }
    }, function(res) {
      if(res && res.data) {
        _this.newGroupName = "";
        _this.showGroupModal = false;
        _this.loadSurveyGroups();
        toast('설문지가 생성되었습니다.');
      } else {
        toast('설문지 생성에 실패했습니다.');
      }
    });
  }

  // 설문지 그룹 삭제
  removeSurveyGroup = (groupId) => {
    if (!window.confirm('이 설문지를 삭제하시겠습니까?')) return;

    let _this = this;
    this.props.deleteSurveyReview({
      _id: groupId,
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1
    }, function(res) {
      if(res && res.data) {
        _this.loadSurveyGroups();
        toast('설문지가 삭제되었습니다.');
      } else {
        toast('설문지 삭제에 실패했습니다.');
      }
    });
  }

  // 그룹 선택 (설문 항목 리스트로 이동)
  selectGroup = (group) => {
    this.selectedGroup = group;
    this.currentView = "questionList";
    // item_ids가 이미 populated된 객체 배열로 반환됨
    this.groupQuestions = group.item_ids || [];
  }

  // 그룹 목록으로 돌아가기
  backToGroupList = () => {
    this.selectedGroup = null;
    this.groupQuestions = [];
    this.currentView = "groupList";
  }

  // 공통 질문 그룹 가상 카드 — 드롭다운에서 설문지 선택 시 호출
  // 선택된 설문지를 isCommon=true 로, 기존 isCommon인 설문지는 isCommon=false 로 일괄 처리
  setCommonSurvey = (surveyId) => {
    const _this = this;
    const newCommon = surveyId ? this.surveyGroups.find(g => g._id === surveyId) : null;
    const previousCommon = this.surveyGroups.find(g => g.isCommon && (!surveyId || g._id !== surveyId));

    const tasks = [];
    if (previousCommon) {
      tasks.push(new Promise((resolve) => {
        _this.props.updateSurveyReview({
          _id: previousCommon._id,
          store_id: _this.teamUser.selStore_id,
          shopNo: _this.teamUser.selShopNo ? _this.teamUser.selShopNo : 1,
          isCommon: false
        }, () => resolve());
      }));
    }
    if (newCommon && !newCommon.isCommon) {
      tasks.push(new Promise((resolve) => {
        _this.props.updateSurveyReview({
          _id: newCommon._id,
          store_id: _this.teamUser.selStore_id,
          shopNo: _this.teamUser.selShopNo ? _this.teamUser.selShopNo : 1,
          isCommon: true
        }, () => resolve());
      }));
    }

    Promise.all(tasks).then(() => {
      _this.surveyGroups = _this.surveyGroups.map(g => {
        if (newCommon && g._id === newCommon._id) return { ...g, isCommon: true };
        if (previousCommon && g._id === previousCommon._id) return { ...g, isCommon: false };
        return g;
      });
      if (newCommon) toast(`'${newCommon.name}'을(를) 모든 상품에 적용했습니다.`);
      else toast('공통 적용을 해제했습니다.');
    });
  };

  // 설문지 isCommon 토글
  toggleGroupIsCommon = (group, e) => {
    e.stopPropagation();
    let _this = this;
    const newIsCommon = !group.isCommon;

    // 활성화하려는 경우, 기존에 활성화된 다른 설문지가 있는지 확인
    if (newIsCommon) {
      const currentCommonGroup = this.surveyGroups.find(function(g) {
        return g.isCommon && g._id !== group._id;
      });

      if (currentCommonGroup) {
        // 기존 활성화된 설문지 비활성화
        this.props.updateSurveyReview({
          _id: currentCommonGroup._id,
          store_id: this.teamUser.selStore_id,
          shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
          isCommon: false
        }, function(res) {
          if (res && res.data) {
            // 새 설문지 활성화
            _this.props.updateSurveyReview({
              _id: group._id,
              store_id: _this.teamUser.selStore_id,
              shopNo: _this.teamUser.selShopNo ? _this.teamUser.selShopNo : 1,
              isCommon: true
            }, function(res2) {
              if (res2 && res2.data) {
                // 로컬 상태 업데이트 (기존 비활성화 + 새로운 활성화)
                _this.surveyGroups = _this.surveyGroups.map(function(g) {
                  if (g._id === group._id) {
                    return { ...g, isCommon: true };
                  } else if (g._id === currentCommonGroup._id) {
                    return { ...g, isCommon: false };
                  }
                  return g;
                });
                toast('모든 상품에 적용됩니다.');
              } else {
                toast('설정 변경에 실패했습니다.');
              }
            });
          }
        });
        return;
      }
    }

    // 비활성화하거나, 기존 활성화된 설문지가 없는 경우
    this.props.updateSurveyReview({
      _id: group._id,
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      isCommon: newIsCommon
    }, function(res) {
      if (res && res.data) {
        // 로컬 상태 업데이트
        _this.surveyGroups = _this.surveyGroups.map(function(g) {
          if (g._id === group._id) {
            return { ...g, isCommon: newIsCommon };
          }
          return g;
        });
        toast(newIsCommon ? '모든 상품에 적용됩니다.' : '모든 상품 적용이 해제되었습니다.');
      } else {
        toast('설정 변경에 실패했습니다.');
      }
    });
  }

  // 선택된 그룹에 질문 추가
  addQuestionToGroup = () => {
    if (!this.newQuestion.question.trim()) {
      toast('질문을 입력해주세요.');
      return;
    }

    if ((this.newQuestion.type === 'radio' || this.newQuestion.type === 'checkbox') && this.newQuestion.options.length === 0) {
      toast('선택형 질문은 최소 1개 이상의 옵션이 필요합니다.');
      return;
    }

    let _this = this;

    // 1. 질문(item) 생성
    this.props.updateSurveyReview({
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      type: 'item',
      name: this.newQuestion.question,
      isActive: true,
      options: {
        questionType: this.newQuestion.type,
        required: this.newQuestion.required,
        choices: this.newQuestion.options,
        maxSelections: this.newQuestion.maxSelections
      }
    }, function(res) {
      if (res && res.data && res.data._id) {
        const newItem = res.data;
        const newItemId = newItem._id;

        // 2. 그룹의 item_ids에 새 질문 ID 추가 (API에는 ID만 전송)
        const currentItemIds = (_this.selectedGroup.item_ids || []).map(function(item) {
          return typeof item === 'object' ? item._id : item;
        });
        const updatedItemIds = [...currentItemIds, newItemId];

        _this.props.updateSurveyReview({
          _id: _this.selectedGroup._id,
          store_id: _this.teamUser.selStore_id,
          shopNo: _this.teamUser.selShopNo ? _this.teamUser.selShopNo : 1,
          item_ids: updatedItemIds
        }, function(groupRes) {
          if (groupRes && groupRes.data) {
            // 로컬 상태 업데이트 (새 아이템 객체 추가)
            const updatedItems = [..._this.groupQuestions, newItem];
            _this.groupQuestions = updatedItems;
            _this.selectedGroup = {
              ..._this.selectedGroup,
              item_ids: updatedItems
            };
            _this.loadSurveyGroups();

            // 폼 초기화
            _this.newQuestion = {
              question: "",
              type: "text",
              required: false,
              options: [],
              maxSelections: null
            };
            _this.showWriteModal = false;
            toast('질문이 추가되었습니다.');
          } else {
            toast('그룹 업데이트에 실패했습니다.');
          }
        });
      } else {
        toast('질문 추가에 실패했습니다.');
      }
    });
  }

  // 선택된 그룹에서 질문 삭제
  removeQuestionFromGroup = (questionId) => {
    let _this = this;

    // 1. 그룹의 item_ids에서 제거 (API에는 ID만 전송)
    const currentItemIds = (this.selectedGroup.item_ids || []).map(function(item) {
      return typeof item === 'object' ? item._id : item;
    });
    const updatedItemIds = currentItemIds.filter(function(id) { return id !== questionId; });

    this.props.updateSurveyReview({
      _id: this.selectedGroup._id,
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      item_ids: updatedItemIds
    }, function(res) {
      if (res && res.data) {
        // 2. 질문(item) 삭제
        _this.props.deleteSurveyReview({
          _id: questionId,
          store_id: _this.teamUser.selStore_id,
          shopNo: _this.teamUser.selShopNo ? _this.teamUser.selShopNo : 1
        }, function(deleteRes) {
          // 로컬 상태 업데이트
          var updatedQuestions = _this.groupQuestions.filter(function(q) { return q._id !== questionId; });
          _this.groupQuestions = updatedQuestions;
          _this.selectedGroup = {
            ..._this.selectedGroup,
            item_ids: updatedQuestions
          };
          _this.loadSurveyGroups();
          toast('질문이 삭제되었습니다.');
        });
      } else {
        toast('질문 삭제에 실패했습니다.');
      }
    });
  }

  // 선택된 그룹 내 질문 순서 변경
  moveQuestionInGroup = (index, direction) => {
    const currentQuestions = [...this.groupQuestions];
    const newIndex = direction === 'up' ? index - 1 : index + 1;
    if (newIndex < 0 || newIndex >= currentQuestions.length) return;

    // 순서 변경
    var temp = currentQuestions[index];
    currentQuestions[index] = currentQuestions[newIndex];
    currentQuestions[newIndex] = temp;

    // API에는 ID만 전송
    const updatedItemIds = currentQuestions.map(function(item) {
      return item._id;
    });

    let _this = this;
    this.props.updateSurveyReview({
      _id: this.selectedGroup._id,
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      item_ids: updatedItemIds
    }, function(res) {
      if (res && res.data) {
        _this.groupQuestions = currentQuestions;
        _this.selectedGroup = {
          ..._this.selectedGroup,
          item_ids: currentQuestions
        };
        _this.loadSurveyGroups();
      }
    });
  }

  // 템플릿 질문을 그룹에 추가
  addTemplateToGroup = () => {
    if (!this.selectedTemplate) {
      toast('템플릿을 선택해주세요.');
      return;
    }

    const template = this.questionTemplates.find(function(t) { return t.id === this.selectedTemplate; }.bind(this));
    if (!template) return;

    let _this = this;

    // 1. 템플릿으로 질문(item) 생성
    this.props.updateSurveyReview({
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      type: 'item',
      name: template.question,
      isActive: true,
      options: {
        questionType: template.type,
        required: template.required,
        choices: template.options,
        maxSelections: template.maxSelections || null
      }
    }, function(res) {
      if (res && res.data && res.data._id) {
        const newItem = res.data;
        const newItemId = newItem._id;

        // 2. 그룹의 item_ids에 새 질문 ID 추가 (API에는 ID만 전송)
        const currentItemIds = (_this.selectedGroup.item_ids || []).map(function(item) {
          return typeof item === 'object' ? item._id : item;
        });
        const updatedItemIds = [...currentItemIds, newItemId];

        _this.props.updateSurveyReview({
          _id: _this.selectedGroup._id,
          store_id: _this.teamUser.selStore_id,
          shopNo: _this.teamUser.selShopNo ? _this.teamUser.selShopNo : 1,
          item_ids: updatedItemIds
        }, function(groupRes) {
          if (groupRes && groupRes.data) {
            // 로컬 상태 업데이트 (새 아이템 객체 추가)
            const updatedItems = [..._this.groupQuestions, newItem];
            _this.groupQuestions = updatedItems;
            _this.selectedGroup = {
              ..._this.selectedGroup,
              item_ids: updatedItems
            };
            _this.loadSurveyGroups();
            _this.selectedTemplate = "";
            toast('템플릿 질문이 추가되었습니다.');
          } else {
            toast('그룹 업데이트에 실패했습니다.');
          }
        });
      } else {
        toast('템플릿 추가에 실패했습니다.');
      }
    });
  }

  // ===== 설문지 상품 그룹 관련 함수 =====

  // 설문지 상품 그룹 선택
  selectSurveyProductGroup = (group) => {
    // 기존 선택된 그룹이 있고 수정 중이면 저장 여부 확인
    if (this.selectedSurveyProductGroup && this.selectedSurveyProductGroup.isEdit) {
      var isConfirm = window.confirm("'" + this.selectedSurveyProductGroup.name + "' 그룹이 선택되어 있습니다. 해당 그룹을 저장하시겠습니까?");
      if (isConfirm) {
        this.saveSurveyProductGroup();
      }
    }

    this.selectedSurveyProductGroup = { ...group, isEdit: true };
    this.surveyProductGroupProducts = group.product_ids || [];
  }

  // 설문지 상품 그룹 추가 + 유효성 검증 (빈 값 / 중복 이름)
  // 모달: 설문지를 특정 상품 그룹에 배정 (인라인)
  assignSurveyToGroupInline = (surveyId, groupId) => {
    const _this = this;
    const idx = this.surveyProductGroups.findIndex(g => g._id === groupId);
    if (idx < 0) return;
    const group = this.surveyProductGroups[idx];
    const otherGroups = this.surveyProductGroups.filter(g => g.surveyReview_id === surveyId && g._id !== groupId);
    if (otherGroups.length > 0) {
      const ok = window.confirm(`이 설문지는 이미 '${otherGroups.map(g => g.name).join(', ')}' 그룹에 적용 중입니다. '${group.name}' 그룹에도 배정하시겠습니까?`);
      if (!ok) return;
    }
    const productIds = (group.product_ids || []).map(p => (p && p._id) ? p._id : p);
    this.props.updateSurveyProductGroup({
      _id: group._id,
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      name: group.name,
      type: group.type || 'share',
      surveyReview_id: surveyId,
      product_ids: productIds,
      parentProduct_ids: [],
      childProduct_ids: []
    }, function(res) {
      if (res && res.data) {
        _this.surveyProductGroups[idx].surveyReview_id = surveyId;
        _this.surveyProductGroups[idx].isEdit = false;
        _this.assigningSurveyId = null;
        toast(`'${group.name}' 그룹에 배정되었습니다.`);
      } else {
        toast('배정에 실패했습니다.');
      }
    });
  };

  addSurveyProductGroupWithValidation = () => {
    const name = (this.newSurveyProductGroupName || '').trim();
    if (!name) {
      this.newGroupError = '그룹 이름을 입력해주세요.';
      return;
    }
    if (this.surveyProductGroups.some(g => g.name === name)) {
      this.newGroupError = '이미 동일한 이름의 그룹이 존재합니다.';
      return;
    }
    this.newGroupError = '';
    this.addSurveyProductGroup();
  };

  // 설문지 상품 그룹 추가
  addSurveyProductGroup = () => {
    if (!this.newSurveyProductGroupName.trim()) {
      toast('그룹 이름을 입력해주세요.');
      return;
    }

    let _this = this;

    // 기존 선택된 그룹이 있고 수정 중이면 저장 여부 확인
    if (this.selectedSurveyProductGroup && this.selectedSurveyProductGroup.isEdit) {
      var isConfirm = window.confirm("'" + this.selectedSurveyProductGroup.name + "' 그룹이 선택되어 있습니다. 해당 그룹을 저장하시겠습니까?");
      if (isConfirm) {
        this.saveSurveyProductGroup();
      }
    }

    // API 호출하여 그룹 생성
    this.props.updateSurveyProductGroup({
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      name: this.newSurveyProductGroupName.trim(),
      type: 'share',
      product_ids: [],
      parentProduct_ids: [],
      childProduct_ids: []
    }, function(res) {
      if (res && res.data) {
        var newGroup = res.data;
        newGroup.isEdit = true;
        newGroup.product_ids = [];
        _this.surveyProductGroups = [..._this.surveyProductGroups, newGroup];
        _this.selectedSurveyProductGroup = newGroup;
        _this.surveyProductGroupProducts = [];
        _this.newSurveyProductGroupName = '';
        toast('그룹이 추가되었습니다.');
      } else {
        toast('그룹 추가에 실패했습니다.');
      }
    });
  }

  // 설문지 상품 그룹 삭제
  removeSurveyProductGroupItem = (groupId, e) => {
    if (e) e.stopPropagation();
    if (!window.confirm('이 그룹을 삭제하시겠습니까?')) return;

    let _this = this;

    this.props.removeSurveyProductGroup({
      _id: groupId,
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1
    }, function(res) {
      if (res && res.data) {
        _this.surveyProductGroups = _this.surveyProductGroups.filter(function(g) {
          return g._id !== groupId;
        });

        if (_this.selectedSurveyProductGroup && _this.selectedSurveyProductGroup._id === groupId) {
          _this.selectedSurveyProductGroup = null;
          _this.surveyProductGroupProducts = [];
        }

        toast('그룹이 삭제되었습니다.');
      } else {
        toast('그룹 삭제에 실패했습니다.');
      }
    });
  }

  // 설문지 상품 그룹 저장
  saveSurveyProductGroup = () => {
    if (!this.selectedSurveyProductGroup) return;

    let _this = this;

    // 상품 ID 배열 추출
    var productIds = this.surveyProductGroupProducts.map(function(p) {
      return typeof p === 'object' ? p._id : p;
    });

    this.props.updateSurveyProductGroup({
      _id: this.selectedSurveyProductGroup._id,
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      name: this.selectedSurveyProductGroup.name,
      type: this.selectedSurveyProductGroup.type || 'share',
      surveyReview_id: this.selectedSurveyProductGroup.surveyReview_id || '',
      product_ids: productIds,
      parentProduct_ids: [],
      childProduct_ids: []
    }, function(res) {
      if (res && res.data) {
        // 로컬 상태 업데이트
        _this.surveyProductGroups = _this.surveyProductGroups.map(function(g) {
          if (g._id === _this.selectedSurveyProductGroup._id) {
            return {
              ..._this.selectedSurveyProductGroup,
              product_ids: _this.surveyProductGroupProducts,
              isEdit: false
            };
          }
          return g;
        });
        _this.selectedSurveyProductGroup.isEdit = false;
        toast('그룹이 저장되었습니다.');
      } else {
        toast('그룹 저장에 실패했습니다.');
      }
    });
  }

  // 상품 선택 모달 열기
  openProductSelectModal = () => {
    this.modals.ModalProductList = true;
  }

  // 특정 그룹의 상품 선택 모달 열기
  @observable editingGroupIndex = null;

  openProductSelectModalForGroup = (idx) => {
    this.editingGroupIndex = idx;
    // 해당 그룹의 상품 목록과 ID를 설정
    var group = this.surveyProductGroups[idx];
    this.surveyProductGroupProducts = group.product_ids || [];
    this.added_ids = (group.product_ids || []).map(function(p) {
      return p._id;
    });
    this.modals.ModalProductList = true;
  }

  // 상품 선택 모달 토글
  productModalToggle = (target, isShow, data) => {
    if (isShow) {
      this.modals[target] = true;
    } else {
      this.modals[target] = !this.modals[target];
      // 모달 닫힐 때 해당 그룹에 상품 반영
      if (!this.modals[target] && this.editingGroupIndex !== null) {
        this.surveyProductGroups[this.editingGroupIndex].product_ids = this.surveyProductGroupProducts;
        this.surveyProductGroups[this.editingGroupIndex].isEdit = true;
        this.editingGroupIndex = null;
      }
    }
  }

  // 상품 그룹에 상품 추가 (모달에서 호출)
  setProductGroup = (list, ids) => {
    this.surveyProductGroupProducts = list;
    if (this.editingGroupIndex !== null) {
      this.surveyProductGroups[this.editingGroupIndex].product_ids = list;
      this.surveyProductGroups[this.editingGroupIndex].isEdit = true;
    } else if (this.selectedSurveyProductGroup) {
      this.selectedSurveyProductGroup.isEdit = true;
    }
  }

  // 그룹에서 상품 제거
  removeProductFromGroup = (productId) => {
    this.surveyProductGroupProducts = this.surveyProductGroupProducts.filter(function(p) {
      return p._id !== productId;
    });
    if (this.selectedSurveyProductGroup) {
      this.selectedSurveyProductGroup.isEdit = true;
    }
  }

  // 인덱스로 그룹에서 상품 제거
  removeProductFromGroupByIndex = (groupIdx, productId) => {
    this.surveyProductGroups[groupIdx].product_ids = this.surveyProductGroups[groupIdx].product_ids.filter(function(p) {
      return p._id !== productId;
    });
    this.surveyProductGroups[groupIdx].isEdit = true;
  }

  // 인덱스로 그룹 저장
  saveSurveyProductGroupByIndex = (idx) => {
    var group = this.surveyProductGroups[idx];
    if (!group) return;

    let _this = this;

    // 상품 ID 배열 추출
    var productIds = (group.product_ids || []).map(function(p) {
      return typeof p === 'object' ? p._id : p;
    });

    this.props.updateSurveyProductGroup({
      _id: group._id,
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      name: group.name,
      type: group.type || 'share',
      surveyReview_id: group.surveyReview_id || '',
      product_ids: productIds,
      parentProduct_ids: [],
      childProduct_ids: []
    }, function(res) {
      if (res && res.data) {
        _this.surveyProductGroups[idx].isEdit = false;
        toast('그룹이 저장되었습니다.');
      } else {
        toast('그룹 저장에 실패했습니다.');
      }
    });
  }

  render() {
    return (
        <div className="main-content">
          <PageTitle/>

          {/* === 설문지 관리 모달 (예전 "설문지 리스트" 탭 내용) === */}
          <Modal open={this.showSurveyListModal} toggle={() => {}} size="lg" className="src-survey-list-modal">
            <ModalHeader toggle={() => this.showSurveyListModal = false}>
              설문지 관리
              <small style={{display: 'block', fontSize: 12, color: '#6B7280', fontWeight: 400, marginTop: 2}}>
                설문지를 만들고, 질문을 편집하거나, 상품 그룹에 배정할 수 있습니다.
              </small>
            </ModalHeader>
            <ModalBody style={{padding: '20px 24px', maxHeight: '80vh', overflowY: 'auto'}}>
          <>
          {/* 그룹 리스트 뷰 */}
          {this.currentView === 'groupList' && (
          <div className="widget-box">
            <div className="section-box">
              <div className="section-tit" style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '16px 20px',
                marginBottom: '12px',
                borderBottom: '1px solid #F1F5F9'
              }}>
                <h3 style={{margin: 0, fontSize: 15, fontWeight: 700, color: '#1F2937'}}>설문지 리스트</h3>
                <Button theme="primary" onClick={this.toggleGroupModal} style={{display: 'inline-flex', alignItems: 'center', gap: 4}}>
                  <FeatherIcon icon="plus" size="16" /> 설문지 추가
                </Button>
              </div>

              <div style={{padding: '20px'}}>
                {this.surveyGroups.length === 0 ? (
                  <div style={{
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    padding: '40px',
                    textAlign: 'center',
                    color: '#999',
                    background: '#fafafa'
                  }}>
                    <FeatherIcon icon="file-text" size="48" style={{marginBottom: '15px', opacity: 0.5}} />
                    <p style={{marginBottom: '10px'}}>등록된 설문지가 없습니다.</p>
                    <p style={{fontSize: '12px'}}>
                      '설문지 추가' 버튼을 클릭하여 새 설문지를 만들어보세요.
                    </p>
                  </div>
                ) : (
                  <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                    {this.surveyGroups.map((group, idx) => (
                      <div
                        key={group._id}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          padding: '15px 20px',
                          border: '1px solid #e0e0e0',
                          borderRadius: '8px',
                          background: '#fff',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'
                        }}
                        onClick={() => this.selectGroup(group)}
                        onMouseEnter={(e) => e.currentTarget.style.background = '#f8f9fa'}
                        onMouseLeave={(e) => e.currentTarget.style.background = '#fff'}
                      >
                        <div style={{display: 'flex', alignItems: 'center', gap: '15px'}}>
                          <span style={{
                            width: '30px',
                            height: '30px',
                            borderRadius: '50%',
                            background: '#007bff',
                            color: '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 'bold',
                            fontSize: '14px'
                          }}>
                            {idx + 1}
                          </span>
                          <div>
                            <div style={{fontWeight: 'bold', fontSize: '15px', marginBottom: '4px', display: 'flex', alignItems: 'center', gap: 6}}>
                              {group.name}
                              {/* 적용 상태 뱃지 */}
                              {(() => {
                                const assignedGroups = (this.surveyProductGroups || []).filter(g => g.surveyReview_id === group._id);
                                if (group.isCommon) {
                                  return <span className="src-status-badge src-status-badge--common">모든 상품 적용</span>;
                                }
                                if (assignedGroups.length > 0) {
                                  return <span className="src-status-badge src-status-badge--assigned">{assignedGroups.length}개 그룹 배정</span>;
                                }
                                return <span className="src-status-badge src-status-badge--unassigned">미배정</span>;
                              })()}
                            </div>
                            <div style={{fontSize: '13px', color: '#666'}}>
                              질문 {(group.item_ids && group.item_ids.length) ? group.item_ids.length : 0}개
                            </div>
                          </div>
                        </div>
                        <div style={{display: 'flex', alignItems: 'center', gap: '15px'}}>
                          {/* 그룹 배정 인라인 (공통 적용 중이면 비활성) */}
                          {!group.isCommon && (
                            <div onClick={(e) => e.stopPropagation()} style={{display: 'flex', alignItems: 'center', gap: 6}}>
                              {this.assigningSurveyId === group._id ? (
                                <FormSelect
                                  autoFocus
                                  value=""
                                  onChange={(e) => {
                                    if (e.target.value) this.assignSurveyToGroupInline(group._id, e.target.value);
                                  }}
                                  onBlur={() => { this.assigningSurveyId = null; }}
                                  style={{width: 200}}
                                >
                                  <option value="">— 상품 그룹 선택 —</option>
                                  {this.surveyProductGroups.map(pg => (
                                    <option key={pg._id} value={pg._id}>
                                      {pg.name}{pg.surveyReview_id === group._id ? ' (이미 배정)' : ''}
                                    </option>
                                  ))}
                                </FormSelect>
                              ) : (
                                <Button
                                  size="sm"
                                  theme="outline-primary"
                                  onClick={() => { this.assigningSurveyId = group._id; }}
                                  title="이 설문지를 상품 그룹에 배정">
                                  <FeatherIcon icon="arrow-right-circle" size="14"/> 그룹 배정
                                </Button>
                              )}
                            </div>
                          )}
                          <Button
                            size="sm"
                            theme="danger"
                            onClick={(e) => {
                              e.stopPropagation();
                              this.removeSurveyGroup(group._id);
                            }}
                          >
                            삭제
                          </Button>
                          <FeatherIcon icon="chevron-right" size="20" style={{color: '#999'}} />
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
          )}

          {/* 설문 항목 리스트 뷰 (그룹 선택 후) */}
          {this.currentView === 'questionList' && this.selectedGroup && (
          <div className="widget-box">
            <div className="section-box">
              <div className="section-tit" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                  <button
                    onClick={this.backToGroupList}
                    style={{
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      padding: '5px',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <FeatherIcon icon="arrow-left" size="20" />
                  </button>
                  <h3>{this.selectedGroup.name}</h3>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                  <FormSelect
                    value={this.selectedTemplate}
                    onChange={(e) => this.selectedTemplate = e.target.value}
                    style={{width: '250px'}}
                  >
                    <option value="">템플릿 선택</option>
                    {this.questionTemplates.map((template) => (
                      <option key={template.id} value={template.id}>
                        {template.label}
                      </option>
                    ))}
                  </FormSelect>
                  <Button theme="secondary" onClick={this.addTemplateToGroup}>
                    템플릿 추가
                  </Button>
                  <Button theme="primary" onClick={this.toggleWriteModal}>
                    <FeatherIcon icon="plus" size="16" /> 질문 추가
                  </Button>
                </div>
              </div>

              <div style={{padding: '20px'}}>
                {this.groupQuestions.length === 0 ? (
                  <div style={{
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    padding: '40px',
                    textAlign: 'center',
                    color: '#999',
                    background: '#fafafa'
                  }}>
                    <FeatherIcon icon="help-circle" size="48" style={{marginBottom: '15px', opacity: 0.5}} />
                    <p style={{marginBottom: '10px'}}>등록된 질문이 없습니다.</p>
                    <p style={{fontSize: '12px'}}>
                      '질문 추가' 버튼을 클릭하여 질문을 추가해보세요.
                    </p>
                  </div>
                ) : (
                  <>
                  <table className="s-table" style={{width: '100%'}}>
                    <colgroup>
                      <col width="60px"/>
                      <col width=""/>
                      <col width="120px"/>
                      <col width="100px"/>
                      <col width="140px"/>
                    </colgroup>
                    <thead>
                      <tr>
                        <th>번호</th>
                        <th>질문</th>
                        <th>유형</th>
                        <th>필수여부</th>
                        <th>관리</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.groupQuestions.map((question, idx) => (
                        <tr key={question._id}>
                          <td style={{textAlign: 'center'}}>{idx + 1}</td>
                          <td
                            style={{textAlign: 'left', cursor: 'pointer', color: '#007bff'}}
                            onClick={() => this.openEditQuestionModal(question)}
                          >
                            {question.name}
                          </td>
                          <td style={{textAlign: 'center'}}>
                            {(question.options && question.options.questionType) === 'text' ? '단답형' :
                             (question.options && question.options.questionType) === 'textarea' ? '장문형' :
                             (question.options && question.options.questionType) === 'radio' ? '단일 선택' :
                             (question.options && question.options.questionType) === 'checkbox' ? '다중 선택' :
                             (question.options && question.options.questionType) === 'rating' ? '별점 선택' : (question.options && question.options.questionType) || '-'}
                          </td>
                          <td style={{textAlign: 'center'}}>
                            {(question.options && question.options.required) ? (
                              <span style={{color: '#ff5252', fontWeight: 'bold'}}>필수</span>
                            ) : (
                              <span style={{color: '#999'}}>선택</span>
                            )}
                          </td>
                          <td style={{textAlign: 'center'}}>
                            <div style={{display: 'flex', gap: '5px', justifyContent: 'center'}}>
                              <button
                                onClick={() => this.moveQuestionInGroup(idx, 'up')}
                                disabled={idx === 0}
                                style={{
                                  padding: '4px 8px',
                                  border: '1px solid #ccc',
                                  borderRadius: '4px',
                                  background: '#fff',
                                  cursor: idx === 0 ? 'not-allowed' : 'pointer',
                                  opacity: idx === 0 ? 0.5 : 1
                                }}
                              >
                                <FeatherIcon icon="arrow-up" size="14" />
                              </button>
                              <button
                                onClick={() => this.moveQuestionInGroup(idx, 'down')}
                                disabled={idx === this.groupQuestions.length - 1}
                                style={{
                                  padding: '4px 8px',
                                  border: '1px solid #ccc',
                                  borderRadius: '4px',
                                  background: '#fff',
                                  cursor: idx === this.groupQuestions.length - 1 ? 'not-allowed' : 'pointer',
                                  opacity: idx === this.groupQuestions.length - 1 ? 0.5 : 1
                                }}
                              >
                                <FeatherIcon icon="arrow-down" size="14" />
                              </button>
                              <Button
                                size="sm"
                                theme="danger"
                                onClick={() => this.removeQuestionFromGroup(question._id)}
                                style={{padding: '4px 8px'}}
                              >
                                삭제
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  </>
                )}
              </div>
            </div>
          </div>
          )}

          {/*<div className="btn-save" style={{textAlign: 'center', padding: '20px'}}>*/}
          {/*  <Button className="save-button" onClick={this.updateSurveyConfig}>저장</Button>*/}
          {/*</div>*/}

          </>
            </ModalBody>
            <div style={{display: 'flex', justifyContent: 'flex-end', padding: '12px 24px', borderTop: '1px solid #E5E7EB', gap: 8}}>
              <Button theme="light" onClick={() => this.showSurveyListModal = false}>닫기</Button>
              <Button theme="primary" onClick={() => { this.showSurveyListModal = false; this.changeTab('product'); }}>
                <FeatherIcon icon="arrow-right" size="14"/> 상품 그룹에 배정하기
              </Button>
            </div>
          </Modal>

          {/* === 메인: 상품 그룹에 설문지 배정 === */}
          {this.activeTab === 'product' && (
          <>
          {/* 그룹 추가 영역 */}
          <div className="widget-box">
            <div className="section-box">
              <div className="section-tit" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16}}>
                <div style={{flex: 1}}>
                  <div style={{display: 'flex', alignItems: 'center', gap: 12}}>
                    <h3 style={{margin: 0}}>상품별 설문지 배정</h3>
                    {/* 설문 리뷰 사용 토글 */}
                    <div style={{display: 'inline-flex', alignItems: 'center', gap: 6, padding: '2px 10px', background: '#F9FAFB', border: '1px solid #E5E7EB', borderRadius: 100}}>
                      <span style={{fontSize: 12, color: '#6B7280'}}>설문 리뷰 사용</span>
                      <label className="src-switch">
                        <input type="checkbox"
                               aria-label="설문 리뷰 사용"
                               checked={this.basicSettings.surveyConfig.enableSurvey === "yes"}
                               onChange={(e) => {
                                 this.basicSettings.surveyConfig.enableSurvey = e.target.checked ? "yes" : "no";
                                 this.updateSurveyConfig();
                               }}/>
                        <span className="src-switch__slider"/>
                      </label>
                    </div>
                  </div>
                  <p style={{margin: '6px 0 0', fontSize: 13, color: '#6B7280', lineHeight: 1.5}}>
                    상품을 그룹으로 묶고, 각 그룹에 서로 다른 설문지를 적용할 수 있습니다.<br/>
                    그룹에 포함되지 않은 상품에는 <b>공통 질문 그룹의 설문지</b>가 자동 적용됩니다.
                  </p>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0, flexWrap: 'wrap', justifyContent: 'flex-end'}}>
                  <div style={{display: 'flex', flexDirection: 'column', gap: 2}}>
                    <FormInput
                      placeholder="새 그룹 이름"
                      value={this.newSurveyProductGroupName}
                      onChange={(e) => { this.newSurveyProductGroupName = e.target.value; this.newGroupError = ''; }}
                      invalid={!!this.newGroupError}
                      style={{width: '220px'}}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          this.addSurveyProductGroupWithValidation();
                        }
                      }}
                    />
                    {this.newGroupError && (
                      <span style={{color: '#DC2626', fontSize: 11}}>{this.newGroupError}</span>
                    )}
                  </div>
                  <Button theme="primary" onClick={() => this.addSurveyProductGroupWithValidation()}>
                    <FeatherIcon icon="plus" size="16" /> 그룹 추가
                  </Button>
                  <Button theme="light" onClick={() => { this.showSurveyListModal = true; }}>
                    <FeatherIcon icon="file-text" size="16" /> 설문지 관리
                  </Button>
                </div>
              </div>
            </div>
          </div>

          {/* 그룹이 없을 때 — 온보딩 빈 상태 */}
          {this.surveyProductGroups.length === 0 && (
            <div className="src-empty-state" style={{marginTop: 20, background: '#F9FAFB', border: '1px solid #E5E7EB', borderRadius: 10}}>
              <FeatherIcon icon="folder-plus" size="40"/>
              <div className="src-empty-state__title">상품 그룹을 만들어 설문지를 배정해 보세요</div>
              <div className="src-empty-state__desc">상단의 "새 그룹 이름"에 이름을 입력하고 <b>그룹 추가</b>를 눌러 시작할 수 있습니다.</div>
            </div>
          )}

          {/* 설문지 _id → 적용된 그룹명 매핑 (드롭다운 상태 뱃지용) */}
          {(() => {
            this._surveyAssignmentMap = {};
            this.surveyProductGroups.forEach(g => {
              if (g.surveyReview_id) {
                if (!this._surveyAssignmentMap[g.surveyReview_id]) this._surveyAssignmentMap[g.surveyReview_id] = [];
                this._surveyAssignmentMap[g.surveyReview_id].push(g.name || '그룹');
              }
            });
            return null;
          })()}

          {/* === 공통 질문 그룹 (가상 카드, 항상 최상단) === */}
          {(() => {
            const commonSurvey = this.surveyGroups.find(g => g.isCommon);
            return (
              <div className="src-group-card src-group-card--common">
                <div className="src-group-card__head" style={{cursor: 'default'}}>
                  <FeatherIcon icon="globe" size="16" style={{color: '#1E40AF'}}/>
                  <div className="src-group-card__title-wrap">
                    <span className="src-group-card__title">공통 질문 그룹</span>
                    <span style={{fontSize: 11, color: '#1E40AF', background: '#DBEAFE', padding: '2px 8px', borderRadius: 100, fontWeight: 600}}>기본 적용</span>
                  </div>
                  <div className="src-group-card__summary">
                    {commonSurvey
                      ? <span className="src-chip">{commonSurvey.name}</span>
                      : <span style={{color: '#9CA3AF'}}>설문지 미선택</span>}
                    <span>다른 그룹에 미배정된 모든 상품에 적용</span>
                  </div>
                </div>
                <div className="src-group-card__body">
                  <label style={{display: 'block', marginBottom: 8, fontWeight: 600, fontSize: 13, color: '#374151'}}>적용할 설문지 (모든 상품 공통)</label>
                  <div style={{display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap'}}>
                    <FormSelect
                      value={commonSurvey ? commonSurvey._id : ''}
                      onChange={(e) => this.setCommonSurvey(e.target.value)}
                      style={{maxWidth: 360, flex: '1 1 260px'}}>
                      <option value="">— 공통 적용할 설문지를 선택하세요 —</option>
                      {this.surveyGroups.map(s => (
                        <option key={s._id} value={s._id}>{s.name}</option>
                      ))}
                    </FormSelect>
                    {commonSurvey && (
                      <button type="button"
                              className="src-unassign-link"
                              onClick={() => {
                                if (window.confirm('공통 적용을 해제하시겠습니까? (다른 그룹에 배정된 설문지는 영향 없음)')) {
                                  this.setCommonSurvey('');
                                }
                              }}>
                        <FeatherIcon icon="x" size="14"/> 공통 적용 해제
                      </button>
                    )}
                  </div>
                  <p style={{margin: '6px 0 0', fontSize: 11, color: '#6B7280'}}>
                    여기서 선택한 설문지는 <b>아래 어느 상품 그룹에도 포함되지 않은 모든 상품</b>에 자동 적용됩니다. 상품 그룹별 설문지가 우선합니다.
                  </p>
                </div>
              </div>
            );
          })()}

          {/* 그룹 카드 리스트 */}
          {this.surveyProductGroups
            .map((group, idx) => ({ group, idx }))
            .sort((a, b) => {
              var aHasCommon = this.surveyGroups.some(function(s) { return s._id === a.group.surveyReview_id && s.isCommon === true; });
              var bHasCommon = this.surveyGroups.some(function(s) { return s._id === b.group.surveyReview_id && s.isCommon === true; });
              if (aHasCommon && !bHasCommon) return -1;
              if (!aHasCommon && bHasCommon) return 1;
              return 0;
            })
            .map(({ group, idx }) => {
              const isCommonSurvey = this.surveyGroups.some(function(s) { return s._id === group.surveyReview_id && s.isCommon === true; });
              const selectedSurvey = group.surveyReview_id ? this.surveyGroups.find(s => s._id === group.surveyReview_id) : null;
              const surveyName = selectedSurvey ? selectedSurvey.name : '설문지 미선택';
              const productCount = (group.product_ids && group.product_ids.length) || 0;
              const isCollapsed = !!this.collapsedGroupIds[group._id];
              const viewMode = this.productViewMode[group._id] || (productCount >= 10 ? 'grid' : 'list');
              const isEditingName = this.editingGroupNameId === group._id;
              const isDirty = !!group.isEdit;

              return (
                <div key={group._id || idx} className={`src-group-card ${isDirty ? 'is-active' : ''}`}>
                  {/* 카드 헤더 (항상 표시 / 접기 가능) */}
                  <div className="src-group-card__head"
                       onClick={() => { if (!isEditingName) this.collapsedGroupIds[group._id] = !isCollapsed; }}>
                    <span className="src-group-card__drag" title="드래그하여 순서 변경" onClick={e => e.stopPropagation()}>
                      <FeatherIcon icon="menu" size="16"/>
                    </span>
                    <FeatherIcon icon="folder" size="16" style={{color: '#6B7280'}}/>
                    <div className="src-group-card__title-wrap">
                      {isEditingName ? (
                        <FormInput value={this.draftGroupName}
                                   onClick={e => e.stopPropagation()}
                                   onChange={e => this.draftGroupName = e.target.value}
                                   onKeyDown={(e) => {
                                     if (e.key === 'Enter') { this.surveyProductGroups[idx].name = this.draftGroupName.trim() || group.name; this.surveyProductGroups[idx].isEdit = true; this.editingGroupNameId = null; }
                                     if (e.key === 'Escape') { this.editingGroupNameId = null; }
                                   }}
                                   style={{maxWidth: 240}}/>
                      ) : (
                        <>
                          <span className="src-group-card__title" title={group.name}>{group.name}</span>
                          <span className="src-group-card__name-edit"
                                title="그룹명 편집"
                                onClick={(e) => { e.stopPropagation(); this.editingGroupNameId = group._id; this.draftGroupName = group.name; }}>
                            <FeatherIcon icon="edit-2" size="12"/>
                          </span>
                        </>
                      )}
                      {isDirty && !isEditingName && <span style={{fontSize: 11, color: '#F59E0B', fontWeight: 600}}>● 미저장</span>}
                      {isCommonSurvey && <span style={{fontSize: 11, color: '#065F46', background: '#D1FAE5', padding: '2px 8px', borderRadius: 100, fontWeight: 600}}>공통 적용 중</span>}
                    </div>
                    <div className="src-group-card__summary" onClick={e => e.stopPropagation()}>
                      <span className="src-chip">{surveyName}</span>
                      <span>상품 {productCount}개</span>
                    </div>
                    <span className="src-group-card__toggle">
                      <FeatherIcon icon={isCollapsed ? 'chevron-down' : 'chevron-up'} size="18"/>
                    </span>
                  </div>

                  {/* 본문 (접힌 상태가 아닐 때만) */}
                  {!isCollapsed && !isCommonSurvey && (
                    <>
                      <div className="src-group-card__body">
                        {/* 설문지 드롭다운 */}
                        <label style={{display: 'block', marginBottom: 8, fontWeight: 600, fontSize: 13, color: '#374151'}}>적용할 설문지</label>
                        <div style={{display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap'}}>
                          <FormSelect
                            value={group.surveyReview_id || ''}
                            onChange={(e) => {
                              const newId = e.target.value;
                              if (newId && this._surveyAssignmentMap && this._surveyAssignmentMap[newId]) {
                                const otherGroups = this._surveyAssignmentMap[newId].filter(n => n !== group.name);
                                if (otherGroups.length > 0 && !window.confirm(`이 설문지는 현재 '${otherGroups.join(', ')}' 그룹에도 적용 중입니다. 그래도 변경하시겠습니까?`)) {
                                  return;
                                }
                              }
                              this.surveyProductGroups[idx].surveyReview_id = newId;
                              this.surveyProductGroups[idx].isEdit = true;
                            }}
                            style={{maxWidth: 360, flex: '1 1 260px'}}>
                            <option value="">— 설문지를 선택하세요 —</option>
                            {this.surveyGroups.map((survey) => {
                              let badge = '미배정';
                              if (survey.isCommon === true) badge = '모든 상품 적용중';
                              else if (this._surveyAssignmentMap && this._surveyAssignmentMap[survey._id]) {
                                badge = this._surveyAssignmentMap[survey._id].join(', ') + ' 적용중';
                              }
                              return (
                                <option key={survey._id}
                                        value={survey._id}
                                        disabled={survey.isCommon === true}>
                                  {survey.name} · {badge}
                                </option>
                              );
                            })}
                          </FormSelect>
                          {group.surveyReview_id && (
                            <button type="button"
                                    className="src-unassign-link"
                                    onClick={() => {
                                      if (window.confirm('이 그룹에서 적용된 설문지를 해제하시겠습니까?')) {
                                        this.surveyProductGroups[idx].surveyReview_id = '';
                                        this.surveyProductGroups[idx].isEdit = true;
                                      }
                                    }}>
                              <FeatherIcon icon="x" size="14"/> 적용 해제
                            </button>
                          )}
                        </div>
                        {!group.surveyReview_id && (
                          <p style={{margin: '6px 0 0', fontSize: 11, color: '#9CA3AF'}}>설문지를 먼저 선택하세요.</p>
                        )}

                        {/* 상품 목록 영역 */}
                        <div className="src-product-panel">
                          <div className="src-product-panel__head">
                            <div className="src-product-panel__title">
                              <FeatherIcon icon="package" size="14"/>
                              <span>상품 목록</span>
                              <span className="src-product-panel__count">{productCount}개 상품</span>
                            </div>
                            {productCount > 0 && (
                              <div className="src-product-panel__view-toggle" role="group" aria-label="상품 목록 뷰 전환">
                                <button type="button"
                                        className={viewMode === 'list' ? 'is-active' : ''}
                                        aria-label="리스트 뷰"
                                        onClick={() => this.productViewMode[group._id] = 'list'}>
                                  <FeatherIcon icon="menu" size="14"/>
                                </button>
                                <button type="button"
                                        className={viewMode === 'grid' ? 'is-active' : ''}
                                        aria-label="그리드 뷰"
                                        onClick={() => this.productViewMode[group._id] = 'grid'}>
                                  <FeatherIcon icon="grid" size="14"/>
                                </button>
                              </div>
                            )}
                          </div>

                          {productCount === 0 ? (
                            <button type="button"
                                    className="src-product-add src-product-add--expanded"
                                    aria-label="이 그룹에 상품 추가"
                                    onClick={() => this.openProductSelectModalForGroup(idx)}>
                              <FeatherIcon icon="plus-circle" size="28"/>
                              <span>여기를 클릭하여 이 그룹에 상품을 추가하세요</span>
                            </button>
                          ) : (
                            <div className={viewMode === 'grid' ? 'src-product-list-grid' : 'src-product-list-horizontal'}>
                              <button type="button"
                                      className={viewMode === 'grid' ? 'src-product-add src-product-add--expanded' : 'src-product-add'}
                                      style={viewMode === 'grid' ? {minHeight: 120} : {}}
                                      aria-label="상품 추가"
                                      onClick={() => this.openProductSelectModalForGroup(idx)}>
                                <FeatherIcon icon="plus" size="18"/>
                                <span>상품 추가</span>
                              </button>
                              {group.product_ids.map((product, pIdx) => (
                                viewMode === 'grid' ? (
                                  <div key={product._id || pIdx} className="src-product-grid-item">
                                    <div className="src-product-thumb" title={product.name || ''}>
                                      <img src={(product.images && product.images.s_1) || 'https://via.placeholder.com/120'}
                                           alt={product.name || ''}/>
                                      <button type="button"
                                              className="src-product-thumb__del"
                                              aria-label={`${product.name || '상품'} 제거`}
                                              onClick={() => {
                                                if (window.confirm(`'${product.name || '이 상품'}'을 이 그룹에서 제거하시겠습니까?`)) {
                                                  this.removeProductFromGroupByIndex(idx, product._id);
                                                }
                                              }}>×</button>
                                    </div>
                                    <div className="src-product-grid-item__name">{product.name}</div>
                                  </div>
                                ) : (
                                  <div key={product._id || pIdx} className="src-product-thumb" title={product.name || ''}>
                                    <img src={(product.images && product.images.s_1) || 'https://via.placeholder.com/90'}
                                         alt={product.name || ''}/>
                                    <div className="src-product-thumb__name">{product.name}</div>
                                    <button type="button"
                                            className="src-product-thumb__del"
                                            aria-label={`${product.name || '상품'} 제거`}
                                            onClick={() => {
                                              if (window.confirm(`'${product.name || '이 상품'}'을 이 그룹에서 제거하시겠습니까?`)) {
                                                this.removeProductFromGroupByIndex(idx, product._id);
                                              }
                                            }}>×</button>
                                  </div>
                                )
                              ))}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* 액션 (삭제 좌 / 저장 우 분리) */}
                      <div className="src-group-card__actions">
                        <button type="button"
                                className="src-delete-link"
                                onClick={(e) => {
                                  if (window.confirm(`'${group.name}' 그룹을 삭제하시겠습니까?`)) {
                                    this.removeSurveyProductGroupItem(group._id, e);
                                  }
                                }}>
                          <FeatherIcon icon="trash-2" size="13"/> 그룹 삭제
                        </button>
                        <Button theme="primary" size="sm"
                                className={isDirty ? 'src-save-dirty' : ''}
                                onClick={() => this.saveSurveyProductGroupByIndex(idx)}>
                          <FeatherIcon icon="save" size="14"/> 저장
                        </Button>
                      </div>
                    </>
                  )}

                  {/* 공통 적용 카드의 접힘 시 안내 */}
                  {!isCollapsed && isCommonSurvey && (
                    <div className="src-group-card__body">
                      <div style={{padding: '20px', textAlign: 'center', color: '#6B7280', background: '#F9FAFB', borderRadius: 8, fontSize: 13}}>
                        <FeatherIcon icon="info" size="16" style={{verticalAlign: '-3px', marginRight: 6, color: '#4A6CF7'}}/>
                        <b>'{surveyName}'</b>은 '모든 상품 적용 중'으로 전체 상품에 우선 적용됩니다. 이 그룹의 별도 배정은 비활성화됩니다.
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </>
          )}

          {/* 설문지 그룹 생성 모달 */}
          <Modal open={this.showGroupModal} toggle={() => {}}>
            <ModalHeader>설문지 추가</ModalHeader>
            <ModalBody>
              <div style={{marginBottom: '20px'}}>
                <label style={{display: 'block', marginBottom: '8px', fontWeight: '500'}}>설문지 이름</label>
                <FormInput
                    placeholder="설문지 이름을 입력하세요"
                    value={this.newGroupName}
                    onChange={(e) => this.newGroupName = e.target.value}
                    style={{width: '100%'}}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        this.addSurveyGroup();
                      }
                    }}
                />
                <p style={{marginTop: '10px', fontSize: '12px', color: '#666'}}>
                  예: 의류 설문, 식품 설문, 배송 만족도 등
                </p>
              </div>

              <div style={{display: 'flex', justifyContent: 'flex-end', gap: '10px', paddingTop: '15px', borderTop: '1px solid #e0e0e0'}}>
                <Button theme="light" onClick={this.toggleGroupModal}>
                  취소
                </Button>
                <Button theme="primary" onClick={this.addSurveyGroup}>
                  추가
                </Button>
              </div>
            </ModalBody>
          </Modal>

          {/* 질문 추가/수정 모달 */}
          <Modal open={this.showWriteModal} toggle={() => {}} size="lg">
            <ModalHeader>{this.isEditMode ? '질문 수정' : '질문 추가'}</ModalHeader>
            <ModalBody>
              <div style={{marginBottom: '20px'}}>
                <div style={{marginBottom: '15px'}}>
                  <label style={{display: 'block', marginBottom: '5px', fontWeight: '500'}}>질문</label>
                  <FormInput
                      placeholder="질문을 입력하세요"
                      value={this.newQuestion.question}
                      onChange={(e) => this.newQuestion.question = e.target.value}
                      style={{width: '100%'}}
                  />
                </div>

                <div style={{marginBottom: '15px'}}>
                  <label style={{display: 'block', marginBottom: '5px', fontWeight: '500'}}>질문 유형</label>
                  <FormSelect
                      value={this.newQuestion.type}
                      onChange={(e) => {
                        this.newQuestion.type = e.target.value;
                        if (e.target.value !== 'radio' && e.target.value !== 'checkbox') {
                          this.newQuestion.options = [];
                        }
                      }}
                      style={{width: '200px'}}
                  >
                    <option value="text">단답형</option>
                    <option value="textarea">장문형</option>
                    <option value="radio">단일 선택</option>
                    <option value="checkbox">다중 선택</option>
                    <option value="rating">별점 선택</option>
                  </FormSelect>
                </div>

                {(this.newQuestion.type === 'radio' || this.newQuestion.type === 'checkbox') && (
                    <div style={{marginBottom: '15px'}}>
                      <label style={{display: 'block', marginBottom: '5px', fontWeight: '500'}}>선택 옵션</label>
                      <div style={{display: 'flex', gap: '10px', marginBottom: '10px'}}>
                        <FormInput
                            placeholder="옵션을 입력하세요"
                            value={this.newOption}
                            onChange={(e) => this.newOption = e.target.value}
                            style={{flex: 1}}
                            onKeyPress={(e) => {
                              if (e.key === 'Enter') {
                                e.preventDefault();
                                this.addOption();
                              }
                            }}
                        />
                        <Button size="sm" theme="primary" onClick={this.addOption}>
                          옵션 추가
                        </Button>
                      </div>

                      {this.newQuestion.options.length > 0 && (
                          <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                            {this.newQuestion.options.map((option, idx) => (
                                <div key={idx} style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  padding: '8px 12px',
                                  background: '#f5f5f5',
                                  borderRadius: '4px'
                                }}>
                                  <span style={{flex: 1}}>{idx + 1}. {option}</span>
                                  <button
                                      onClick={() => this.removeOption(idx)}
                                      style={{
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'pointer',
                                        color: '#999',
                                        fontSize: '18px'
                                      }}
                                  >
                                    ×
                                  </button>
                                </div>
                            ))}
                          </div>
                      )}
                    </div>
                )}

                {this.newQuestion.type === 'checkbox' && (
                    <div style={{marginBottom: '15px'}}>
                      <label style={{display: 'block', marginBottom: '5px', fontWeight: '500'}}>최대 선택 개수</label>
                      <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                        <FormInput
                            type="number"
                            min="1"
                            max={this.newQuestion.options.length || 999}
                            value={this.newQuestion.maxSelections || ''}
                            onChange={(e) => {
                              const value = e.target.value;
                              this.newQuestion.maxSelections = value ? parseInt(value) : null;
                            }}
                            placeholder="제한 없음"
                            style={{width: '150px'}}
                        />
                        <span>개까지 선택 가능</span>
                      </div>
                    </div>
                )}

                <div style={{marginBottom: '15px'}}>
                  <FormCheckbox
                      checked={this.newQuestion.required}
                      onChange={(e) => this.newQuestion.required = e.target.checked}
                  >
                    필수 질문으로 설정
                  </FormCheckbox>
                </div>
              </div>

              {/* 버튼 영역 */}
              <div style={{display: 'flex', justifyContent: 'flex-end', gap: '10px', paddingTop: '15px', borderTop: '1px solid #e0e0e0'}}>
                <Button theme="light" onClick={this.toggleWriteModal}>
                  취소
                </Button>
                {this.isEditMode ? (
                  <Button theme="primary" onClick={this.updateQuestion}>
                    수정
                  </Button>
                ) : (
                  <Button theme="primary" onClick={this.addQuestionToGroup}>
                    질문 추가
                  </Button>
                )}
              </div>
            </ModalBody>
          </Modal>

          {/* 상품 선택 모달 */}
          <ModalProductList
            isShow={this.modals.ModalProductList}
            modal="ModalProductList"
            modalToggle={this.productModalToggle}
            setGroup={this.setProductGroup}
            inGroup={this.surveyProductGroupProducts}
            added_ids={this.added_ids}
          />
        </div>
    )
  }
}

export default surveyReviewConfig;
